import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Header, Footer } from '../Common';
import Accessories from '../../Common/Accessories';

/* Placeholder imagery (reuse ABC-SE product assets until CLS cataloch ships) */
import bulkFest from '../../../../assets/abc-se/accessories/party-overall.jpg';
import bulkVogn from '../../../../assets/abc-se/accessories/standard-overall.jpg';
import accSprayCans from '../../../../assets/abc-se/products/acc-spray-cans.jpg';
import accMarkers from '../../../../assets/abc-se/products/acc-markers.jpg';
import accPaintGirl from '../../../../assets/abc-se/products/acc-paint-girl.jpg';
import accConfettiGirl from '../../../../assets/abc-se/products/acc-confetti-girl.jpg';
import accPointtrojen from '../../../../assets/abc-se/products/acc-pointtrojen.jpg';
import accSprayCans2 from '../../../../assets/abc-se/products/acc-spray-cans-2.jpg';
import accSprayCans3 from '../../../../assets/abc-se/products/acc-spray-cans-3.jpg';
import accSprayCans4 from '../../../../assets/abc-se/products/acc-spray-cans-4.jpg';

/* ── Product cataloch (CLS-SE — Danish copy) ── */
const BULK_PRODUCTS = [
  { id: 'bulk-1', slug: 'partyoverallen', image: bulkFest, imageAlt: 'Festoverallen', title: 'FESTHELDRAGTEN', price: '159:-' },
  { id: 'bulk-2', slug: 'flakoverallen', image: bulkVogn, imageAlt: 'Vognoverallen', title: 'VOGNHELDRAGTEN', price: '159:-' },
];

const ACCESSORY_PRODUCTS = [
  { id: 'acc-1', slug: 'spraymaling', image: accSprayCans, imageAlt: 'Sprejfärg', title: 'SPREJFÄRG', price: '59:-' },
  { id: 'acc-2', slug: 'tuscher', image: accMarkers, imageAlt: 'Tuscher', title: 'TUSCHER', price: '79:-' },
  { id: 'acc-3', slug: 'tekstilfärg', image: accPaintGirl, imageAlt: 'Tekstilfärg', title: 'TEKSTILFARVE', price: '49:-' },
  { id: 'acc-4', slug: 'konfetti-kit', image: accConfettiGirl, imageAlt: 'Konfetti Kit', title: 'KONFETTI KIT', price: '39:-' },
];

const BOTTOM_PRODUCTS = [
  { id: 'bot-1', slug: 'pointtrojen', image: accPointtrojen, imageAlt: 'Pointtröjan', title: 'POINTTRÖJAN', price: '89:-' },
  { id: 'bot-2', slug: 'spraymaling-sat', image: accSprayCans2, imageAlt: 'Sprejfärgsset', title: 'SPREJFÄRGSSET', price: '179:-' },
  { id: 'bot-3', slug: 'spraymaling-neon', image: accSprayCans3, imageAlt: 'Sprejfärg Neon', title: 'SPREJFÄRG NEON', price: '69:-' },
  { id: 'bot-4', slug: 'spraymaling-metallic', image: accSprayCans4, imageAlt: 'Sprejfärg Metallic', title: 'SPREJFÄRG METALLIC', price: '99:-' },
];

const TABS = [
  { key: 'alle', label: 'Alle' },
  { key: 'overalls', label: 'Overaller' },
  { key: 'accessories', label: 'Tillbehör' },
];

const CLSSEAccessories = () => {
  const navigate = useNavigate();
  return (
    <Accessories
      brand="CLS"
      Header={Header}
      Footer={Footer}
      bannerTag="Vandafviskicka och hållbar"
      bannerTitle="Overaller & mere"
      tabs={TABS}
      showTabs={false}
      bulkProducts={BULK_PRODUCTS}
      accessoryProducts={ACCESSORY_PRODUCTS}
      bottomProducts={BOTTOM_PRODUCTS}
      fullwidth={{
        subtitle: '50.000+ ELEVER VÄLJER OSS VARJE ÅR',
        mainCopy: 'Vi erbjuder snabb leverans och attraktiva paketlösningar, och du kan beställa säkert med över 100 års erfarenhet.',
        tags: ['Kampagne', 'Kampagne', 'Kampagne'],
      }}
      onBulkClick={(slug) => navigate(`/clothing/cls-se/bulk-product/${slug}`)}
      onAccessoryClick={(slug) => navigate(`/clothing/cls-se/product-details/${slug}`)}
    />
  );
};

export default CLSSEAccessories;
